// VERSION 1.0.0
// AUTHOR: AGALYA

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/*************** FETCH TRANSFER LOG START  ******************/
export const fetchTransferLogData = (fetchData: any) => {
	const data = {
		FetchTransferLogDataToken: fetchData,
	};
	const url = `${API_URL}fetchTransferLog`;
	return makeApiCall(url, data);
};
/*************** FETCH TRANSFER LOG END  ******************/

/***************  GET MEMBER APPROVE LIST START  ******************/
export const getMemberApproveListData = (fetchData: any) => {
	const data = {
		GetMemberApproveListDataToken: fetchData,
	};
	const url = `${API_URL}getMemberApproveList`;
	return makeApiCall(url, data);
};
/***************  GET MEMBER APPROVE LIST END  ******************/

/***************  CHANGE STATUS TRANSFER LOG START ******************/
export const changeStatusTransferLogData = (fetchData: any) => {
	const data = {
		ChangeStatusTransferLogToken: fetchData,
	};
	const url = `${API_URL}changeStatusTransferLog`;
	return makeApiCall(url, data);
};
/***************  CHANGE STATUS TRANSFER LOG END ******************/

/*********  MEMBER FOR TRANSFER CENTER START *********/
export const memberForTransferCenterData = (fetchData: any) => {
	const data = {
		GetMemberForTransferCenterToken: fetchData,
	};
	const url = `${API_URL}getMembersForTransferCenter`;
	return makeApiCall(url, data);
};
/*********  MEMBER FOR TRANSFER CENTER END *********/
